import { request2 } from '../network/request'

// 词汇量挑战榜
export function GetVocabularyChallengeRanking(count = 30) {
    return request2({
        url: '/api2/TZsbWordWebApi0714hhwd/Statistics/GetVocabularyChallengeRanking',
        method: 'get',
        params: { count}
    })
}

// 获取学习坚持榜报表
export function GetStudyPersistIn() {
    return request2({
        url: '/api2/TZsbWebTeachApi/TeachingStatistics/GetStudyPersistIn',
        method: 'get',
    })
}

// 获取早到进步之星列表
export function GetTopStudetnReportEarlyList(take = 30) {
    return request2({
        url: '/api2/TZsbWebTeachApi/TeachingStatistics/GetTopStudetnReportEarlyList',
        method: 'get',
        params: { take }
    })
}

// 单词进步之星排行
export function GetTopStudetnReportWordList(count = 30) {
    return request2({
        url: '/api2/TZsbWebTeachApi/TeachingStatistics/GetTopStudetnReportWordList',
        method: 'get',
        params: { count}
    })
}

// 获取作业达人榜接口
export function GetWorkExpertList() {
    return request2({
        url: '/api2/TZsbWebTeachApi/TeachingStatistics/GetWorkExpertList',
        method: 'get',
    })
}

// 作业进步之星
export function GetTopStudetnReportWorkList(take = 30) {
    return request2({
        url: '/api2/TZsbWebTeachApi/TeachingStatistics/GetTopStudetnReportWorkList',
        method: 'get',
        params: { take }
    })
}

// 获取线下考试统计、线下考试平均分(二合一)
export function GetOfflineExaminationAverageScoresV2(data,yearId) {
    return request2({
        url: `/api2/TZsbWebProductApi/Examination/GetOfflineExaminationAverageScoresV2?yearId=${yearId}`,
        method: 'post',
        data: data
    });
}

// 获取考试进步之星
export function GetTopStudetnReportExamList(take = 30) {
    return request2({
        url: '/api2/TZsbWebTeachApi/TeachingStatistics/GetTopStudetnReportExamList',
        method: 'get',
        params: { take }
    });
}

// 获取课堂活跃达人榜
export function GetClassroomActivity() {
    return request2({
        url: '/api2/TZsbWebTeachApi/TeachingStatistics/GetClassroomActivity',
        method: 'get',
    });
}

// 获取课堂进步之星列表
export function GetTopStudetnReportCourseList(take = 30) {
    return request2({
        url: '/api2/TZsbWebTeachApi/TeachingStatistics/GetTopStudetnReportCourseList',
        method: 'get',
        params: { take }
    });
}

// 获取当天课时的今日寄语
export function GetTopStudentInfo(gradeIds) {
    return request2({
        url: '/api2/TZsbWebTeachApi/TeachingStatistics/GetTopStudentInfo',
        method: 'post',
        data: gradeIds
    });
}

// 获取综合学霸榜总榜
export function GetTopStudentDataList() {
    return request2({
        url: '/api2/TZsbWebTeachApi/TeachingStatistics/GetTopStudentDataList',
        method: 'get',
    });
}